export function quoteStatus(quote: { timeUtc: string; bid: number; ask: number } | undefined, now: number, maxAgeSeconds = 30) {
  if (!quote || !Number.isFinite(Date.parse(quote.timeUtc)) || !Number.isFinite(quote.bid) ||
      !Number.isFinite(quote.ask) || quote.bid <= 0 || quote.ask < quote.bid) return 'Stale / unavailable';
  const age = now - Date.parse(quote.timeUtc);
  if (age < -5000) return 'Future timestamp — check broker clock';
  return age > maxAgeSeconds * 1000 ? 'Stale / unavailable' : 'Fresh';
}
